import React, { Component } from 'react';
import { compose } from 'redux'
import { connect } from 'react-redux';
import withAuth from '../../components/withAuth';
import Typography from '@material-ui/core/Typography';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { withStyles } from '@material-ui/core/styles';
import QRCodeTab from '../../components/ComponentsPark/QRCodeTab';
import ManualSearchTab from '../../components/ComponentsPark/ManualSearchTab';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { searchComponent, clearComponentsSearch, setSelectedTab } from '../../redux/componentsPark/componentsParkActions'
import { getSearchHistoryType, getSearchHistoryLines } from '../../redux/searchHistory/searchHistoryActions'
import ModalButtonOption from '../../components/Modal/ModalButtonOption';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from "@material-ui/core/Button/Button";
import DialogActions from '@material-ui/core/DialogActions';
import ValidateIcon from '@material-ui/icons/Check';
import SearchIcon from '@material-ui/icons/Search';
import { EQUIPMENT_CODE } from '../../redux/searchHistory/searchHistoryConstants';
import ParksTab from '../../components/ComponentsPark/ParksTab';
import ExtranetComponentPark from './ExtranetComponentPark';

function TabContainer({ children, dir }) {
    return (
        <Typography component="div" dir={dir}>
            {children}
        </Typography>
    );
}

const styles = () => ({
    root: {
        flexGrow: 1,
        justify: 'center',
    },
    grid: {
        width: "100%",
        margin: 0,
        textAlign: 'center'
    },
    icon: {
        fontSize: 48,
        display: 'block',
        width: "48px",
        height: "48px",
        marginLeft: 'auto',
        marginRight: 'auto',
    },
});

class ComponentsPark extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedTab: 0,
            openChoiceModal: false,
        }

        this.qrCodeTab = React.createRef();

        this.props.getSearchHistoryLines(getSearchHistoryType(EQUIPMENT_CODE));
    }

    componentDidMount() {
        this.handleClearComponentsSearch()
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let modifiedState = prevState;

        if (nextProps.componentsPark.selectedTab !== prevState.selectedTab) {
            modifiedState.selectedTab = nextProps.componentsPark.selectedTab
        }

        return modifiedState
    }

    handleClearComponentsSearch() {
        this.props.clearComponentsSearch();

        if (this.props.modalMode)
            this.props.cancelVisualizingEquipment();
    }

    handleChange = (event, value) => {
        this.setState({ selectedTab: value });
        this.props.setSelectedTab(value);
    };

    handleChangeIndex = index => {
        this.setState({ selectedTab: index });
        this.props.setSelectedTab(index);
    };

    visualizeEquipment() {
        this.props.searchComponent(this.state.input);
        this.props.visualizeEquipment(this.state.input);
        this.closeChoicesModal();
    }

    searchEquipment(input) {
        if (!this.props.modalMode) {
            this.props.searchComponent(input);
            return;
        }

        this.setState({
            openChoiceModal: true,
            input,
        })
    }

    selectEquipment() {
        this.props.selectEquipment(this.state.input);
        this.closeChoicesModal();
    }

    closeChoicesModal() {
        this.setState({
            openChoiceModal: false,
            input: '',
        })

        this.qrCodeTab.current.clearResult();
    }

    render() {
        const { classes } = this.props;
        let element;

        if (this.props.componentsPark.currentComponent)
            element = (
                <ExtranetComponentPark />
            );
        else
            element = (
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin without-side-padding">
                    <AppBar position="static" color="default">
                        <Tabs value={this.state.selectedTab} onChange={this.handleChange}
                            indicatorColor="primary" textColor="primary" variant="fullWidth" >
                            {this.props.isExtranetApp ? (<Tab label="Parcs" />) : null}
                            <Tab label="QR Code" />
                            <Tab label="Saisie manuelle" />
                        </Tabs>
                    </AppBar>
                    <SwipeableViews axis='x' index={this.state.selectedTab} onChangeIndex={this.handleChangeIndex} >
                        {this.props.isExtranetApp ? (
                            <TabContainer>
                                <ParksTab />
                            </TabContainer>
                        ) : null}
                        <TabContainer>
                            <QRCodeTab ref={this.qrCodeTab} componentPark={this.searchEquipment.bind(this)} />
                        </TabContainer>
                        <TabContainer className="col-lg-12 col-md-12 col-sm-12 col-12">
                            <ManualSearchTab searchEquipment={this.searchEquipment.bind(this)} />
                        </TabContainer>
                    </SwipeableViews>
                    <Dialog open={this.state.openChoiceModal} aria-labelledby="form-dialog-title">
                        <DialogTitle id="form-dialog-title">{"Équipement: " + this.state.input}</DialogTitle>
                        <DialogContent className="without-side-padding">
                            <ModalButtonOption name={"Sélectionner"} onClick={this.selectEquipment.bind(this)} icon={
                                (<ValidateIcon className={classes.icon} />)
                            } />
                            <ModalButtonOption name={"Visualiser"} onClick={this.visualizeEquipment.bind(this)} icon={
                                (<SearchIcon className={classes.icon} />)
                            } />
                        </DialogContent>
                        <DialogActions>
                            <Button className="button red-button" onClick={this.closeChoicesModal.bind(this)} color="primary">
                                Annuler
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )

        return (
            <div className={classes.root}>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                    <div className={classes.grid} >
                        {element}
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        componentsPark: state.componentsPark,
        isExtranetApp: state.context.isExtranetApp,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        searchComponent: (code) => dispatch(searchComponent(code)),
        clearComponentsSearch: () => dispatch(clearComponentsSearch()),
        setSelectedTab: (selectedTab) => dispatch(setSelectedTab(selectedTab)),
        getSearchHistoryLines: (type) => dispatch(getSearchHistoryLines(type)),
    };
};

export default compose(withAuth, withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(ComponentsPark);
